module.exports = __webpack_public_path__ + "static/img/page5.63620753.png";